if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (this.form.querySelector('[name=id]')) {
          this.form.querySelector('[name=id]').disabled = false;
        }
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cartDrawer = document.querySelector('cart-drawer');
        this.cartNotification = document.querySelector('cart-notification');
        window._learnq = _learnq || [];
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        const submitButton = this.querySelector('[type="submit"]');
        const submitButtonText = this.querySelector('.boost-pfs-quickview-cart-btn-text');
        const submitButtonTextSpan = this.querySelector('span');
        const errorMsg = this.querySelector('#boost-pfs-addtocart-error-label');
        if (submitButton.classList.contains('loading')) return;

        this.handleErrorMessage();

        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
        if (submitButtonText) {
          submitButtonText.innerHTML = 'Adding';
        }
        if (submitButtonTextSpan) {
          submitButtonTextSpan.innerHTML = 'Adding';
        }
        this.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        formData.append('sections_url', window.location.pathname);
        config.body = formData;

        fetch('/cart/add.js', config)
          .then((response) => response.json())
          .then(async (response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              return;
            }

            try {
              const response = await fetch('/cart.js');
              const cart = await response.json();

              const giftWithPurchase = new GiftWithPurchase(cart);
              await giftWithPurchase.loadGWP();
            } catch (error) {
              console.error('Error fetching cart data:', error);
            }

            this.cartDrawer.loadContent(true);

            if (submitButtonText) {
              submitButtonText.innerHTML = 'Added';
            }
            if (submitButtonTextSpan) {
              submitButtonTextSpan.innerHTML = 'Added';
            }
            if ($('.quick-view-custom.active').length) {
                $('.quick-view-custom').removeClass('active');
              }
            // Revert after 10 seconds (10,000 milliseconds)
            setTimeout(function() {
              if (submitButtonText) {
                submitButtonText.innerHTML = 'Add to Bag';
              }
              if (submitButtonTextSpan) {
                submitButtonTextSpan.innerHTML = 'Add to Bag';
              }
            }, 10000);
            // close PFS cart after adding product 1 sec
            setTimeout(() => {
              if (jQ('.boost-pfs-quickview-close').length)
                jQ('.boost-pfs-quickview-close').trigger('click');
              if (jQ('.close-wrapper-quickview').length)
                jQ('.close-wrapper-quickview').trigger('click');
            }, 1000);
            this.updateCartBubble(config);
          })
          .catch((e) => {
            if (errorMsg) {
              errorMsg.innerHTML = 'Your product is out of stock';
            }
            if (submitButtonText) {
              submitButtonText.innerHTML = 'Add to cart';
            }
            console.error(e);
          })
          .finally(() => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
          });
      }

      updateCartBubble(config) {
        const cartBubbles = document.querySelectorAll('.cart-icon-bubble');
        const newCartBubbles = document.querySelectorAll('.cart-count-bubble-value');
        if (!cartBubbles) return;

        fetch(window.routes.cartUrl, config)
          .then((response) => response.json())
          .then((response) => {
            if (response && response.status) {
              this.handleErrorMessage(response.description);
              return;
            }

            var cart = {
              total_price: response.total_price / 100,
              $value: response.total_price / 100,
              total_discount: response.total_discount,
              original_total_price: response.original_total_price / 100,
              items: response.items,
            };

            window._learnq = window._learnq || [];
            window._learnq.push(['track', 'Added to Cart', cart]);
            const cartItemCount = response.item_count;
            cartBubbles.forEach((item) => {
              item.innerHTML = cartItemCount;
            });
            newCartBubbles.forEach((item) => {
              item.innerHTML = cartItemCount;
              if (cartItemCount > 0) {
                item.classList.add('show');
              } else {
                item.classList.remove('show');
              }
            });
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper?.querySelector('.product-form__error-message');

        this.errorMessageWrapper?.toggleAttribute('hidden', !errorMessage);

        if (errorMessage && this.errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
